import React from 'react';
import './App.css';
import Layout from "./Components/Layout/Layout";
import Router from "./utils/Router";
import 'antd/dist/antd.css';
import Collections from "./utils/Collections/Collections";
import Socket from "./utils/Socket/Socket";
import User from "./utils/User/User";
import {DacState} from "./Store/Reducers/Dac/types";
import {CollectionsState} from "./Store/Reducers/Collections/types";
import {initCollections, udpateCollections} from "./Store/Reducers/Collections/actions";
import {connect, ConnectedProps} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import queryString from 'query-string';
import './globalCSS/vars.scss';

interface RootState {
    dacReducer: DacState,
    collectionsReducer: CollectionsState,
}

const mapState = (state: RootState) => ({
    societyReducer: state.dacReducer.society,
    billingReducer: state.dacReducer.billing,
    collectionsReducer: state.collectionsReducer
});

const mapDispatch = {
    updateCollections: (collection: string, value: any) => udpateCollections(collection, value),
    initCollections: (value: any) => initCollections(value)
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends RouteComponentProps {
    updateCollections: typeof udpateCollections,
    initCollections: typeof initCollections,
}

type PropsType = Props & PropsFromRedux;

interface State {
    auth: boolean
}

class App extends React.Component<PropsType, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            auth: false,
        }
    }

    componentDidMount() {
        // First authenticate before setting up socket connection
        this.testToken();
        // Move socket setup after successful authentication
    }

    watchCrudLive() {
        Socket.live((res: any) => {
            this.props.updateCollections(res.collection, res.data);
        })
    }

    testToken = () => {
        const token = queryString.parse(this.props.location.search).token || localStorage.getItem('userToken');

        console.log("testToken", token)
        
        if (!User.token()) {
            if (token) {
                console.log("REDIRECT VERIF TOKEN")
                this.redirectVerifToken(token);
            } else {
                // window.location.replace(process.env.REACT_APP_WANUP + "");
                console.log("NO TOKEN")
            }
        } else {
            console.log("REDIRECT VERIF TOKEN")
            this.redirectVerifToken(User.token(), true);
        }
    }

    redirectVerifToken = (token?: any, exist?: boolean) => {
        User.checkValidateToken(token)
            .then(resToken => {
                console.log("resToken", resToken)
                if (resToken) {
                    if (!exist) {
                        User.setToken(token);
                    }
                    this.props.history.push("/Devis");
                    
                    // First initialize collections
                    Collections.globalRead(this.props.initCollections, this.props.collectionsReducer);
                    // Then setup socket connection
                    this.watchCrudLive();
                } else {
                    console.log("token invalid", resToken)
                    User.removeToken();
                    // window.location.replace(process.env.REACT_APP_WANUP + "");
                    console.log("NO TOKEN")
                }
            }).catch(err => {
                console.log("err", err)
                console.error(err)
                    User.removeToken();
                    // window.location.replace(process.env.REACT_APP_WANUP + "");
                    console.log("NO TOKEN CATCH")
        })
    }

    render() {
            return (
                <Layout>
                    {/*<Dialog />*/}
                    <Router/>
                </Layout>
            );
    }
}

export default withRouter(connector(App));
